import React from 'react'
import helmail from "../images/HELP LINE MAIL NEW.jpg";


function BethuaMap() {
  return (
    <div>


<div className="album py-0">

<div className="container">

  <div className="row">
  <div className="col-md-6 mt-3">
  <img src={helmail} className="d-block w-100" alt="Best Garments showroom in Bethuadahari, West Bengal"/>

</div>
<div className="col-md-6 mt-3 ">
<iframe className="iframe-fluid " width="520" height="333" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=Siddheshwari%20Bastralaya,%20Patuli%20Ghat%20Rd,%20opposite%20Siddheswari%20Bastralay,%20Bethuadahari,%20West%20Bengal%20741126%20+(Siddheshwari%20Bastralaya,%20Patuli%20Ghat%20Rd,%20opposite%20Siddheswari%20Bastralay,%20Bethuadahari,%20West%20Bengal%20741126)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe> 

</div>
  <iframe className='mt-3' src="https://www.google.com/maps/embed?pb=!4v1741236822294!6m8!1m7!1sR6_Upcl8rDZJ2g3rDnZ0Rg!2m2!1d23.60822871682561!2d88.38142888966256!3f166.9637332170796!4f19.816778549677593!5f0.7820865974627469" width="600" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
 

  </div>
</div>

</div>


    </div>
  )
}

export default BethuaMap